import avoidance_options from '$tablet-app/src/app/recipes/data/avoidances';
import {
  setMealAvoidanceDegree,
  toggleMealAvoidance,
} from '$tablet-app/src/app/recipes/models';
import {
  MealAvoidance,
  MealAvoidanceCategory,
} from '$tablet-app/src/app/recipes/types';
import React from 'react';
import { ScrollView } from 'react-native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';
import AvoidancePreferenceRow from './AvoidancePreferenceRow';

const AvoidPreferencesView = () => {
  const avoidances = useMealPreferenceDialogState(
    (state) => state.draft_preferences.avoidances
  );
  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const avoidance_categories = avoidances?.map((a) => a.category) || [];

  const onPress = (avoidance: MealAvoidanceCategory) =>
    update({
      avoidances: toggleMealAvoidance(avoidances || [], avoidance),
    });

  const onSwitchSelection = (avoidance: MealAvoidance) =>
    update({
      avoidances: setMealAvoidanceDegree(avoidances || [], avoidance),
    });

  return (
    <ScrollView>
      {avoidance_options.map((avoidance) => (
        <AvoidancePreferenceRow
          key={avoidance.category}
          {...avoidance}
          degree={
            avoidances?.find((a) => a.category === avoidance.category)?.degree
          }
          active={avoidance_categories.includes(avoidance.category)}
          onPress={onPress}
          onSwitchSelection={onSwitchSelection}
        />
      ))}
    </ScrollView>
  );
};

export default AvoidPreferencesView;
